import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { getPlatformLabel } from '../../config/platforms.config';

const PlatformLabel = ({ value }) => (
  <Typography variant="body2" component="span">
    {getPlatformLabel(value)}
  </Typography>
);

PlatformLabel.propTypes = {
  value: PropTypes.string.isRequired,
};

export default PlatformLabel;
